module.exports = __webpack_public_path__ + "static/media/img-promising-company@2x.46fa37e8.png";